import React from "react";
import CustomizedSteppers from "../../components/Stepper/CustomizedSteppers";

const EmptyDashboard = ({
  navigation,
  activeStep,
  setNavigation,
  setActiveStep,
  logoDimensionamento,
  progressStats,
}) => {
  return (
    <>
      <div className="md:px-8 px-4 mt-4 flex-1 w-full overflow-y-hidden overflow-x-hidden bg-[#fff] flex flex-col text-secondary justify-between max-h-[95vh] min-h-[15vh]">
        <div className="w-full pl-4 md:pl-0">
          <CustomizedSteppers
            navigation={navigation}
            activeStep={activeStep}
            setNavigation={setNavigation}
            setActiveStep={setActiveStep}
          />
        </div>
      </div>
      <div className="flex flex-col items-center justify-center py-8 px-4 max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Bem-vindo ao{" "}
            <span className="text-emerald-700">Dimensionamento de Redes</span>
          </h1>
          <p className="text-lg text-gray-600">
            Os gráficos e mapas serão apresentados conforme os dados forem
            coletados.
          </p>
        </div>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-200 flex flex-col items-center">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Acompanhamento da Coleta
            </h2>{" "}
            <p className="text-gray-600 text-center mb-4">
              Visualize em tempo real o avanço da pesquisa e o estado atual da
              coleta de dados.
            </p>
            <div className="relative w-full flex items-center justify-center py-4">
              <div className="relative w-44 h-44 group">
                <div className="absolute inset-0 flex items-center justify-center">
                  <svg
                    className="absolute"
                    width="100%"
                    height="100%"
                    viewBox="0 0 120 120"
                  >
                    <circle
                      cx="60"
                      cy="60"
                      r="54"
                      fill="none"
                      stroke="#f3f4f6"
                      strokeWidth="10"
                    />
                  </svg>

                  <div className="absolute inset-0 bg-emerald-500 rounded-full opacity-0 group-hover:opacity-20 transition-opacity duration-500 blur-xl"></div>
                  <svg
                    className="absolute animate-pulse"
                    width="100%"
                    height="100%"
                    viewBox="0 0 120 120"
                  >
                    <circle
                      cx="60"
                      cy="60"
                      r="54"
                      fill="none"
                      stroke="#368C5D"
                      strokeWidth="10"
                      strokeDasharray={`${
                        (progressStats.percent * 339.292) / 100
                      } 339.292`}
                      strokeDashoffset="0"
                      strokeLinecap="round"
                      transform="rotate(-90 60 60)"
                      className="transition-all duration-1000 ease-out"
                      style={{
                        filter:
                          "drop-shadow(0px 0px 3px rgba(54, 140, 93, 0.5))",
                      }}
                    />
                  </svg>

                  <img
                    src={logoDimensionamento}
                    alt="Logo Dimensionamento"
                    className="z-10 w-32 h-32 transition-all duration-500 group-hover:scale-110"
                    style={{
                      opacity: 0.5 + progressStats.percent / 200,
                      filter: `saturate(${50 + progressStats.percent / 2}%)`,
                    }}
                  />
                </div>

                <div className="absolute inset-0 flex items-center justify-center z-20">
                  <div className="text-2xl font-bold text-emerald-700 bg-white bg-opacity-70 rounded-full h-14 w-14 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    {progressStats.percent}%
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full mt-2 text-center">
              <p className="text-sm text-emerald-700 font-semibold">
                {progressStats.completed} de {progressStats.total} etapas
                concluídas
              </p>
              <p className="text-xs text-gray-500 mt-1">
                A visualização completa dos dados será liberada ao final da
                coleta
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-200 flex flex-col items-center">
            <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-8 w-8 text-emerald-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-800 mb-2 text-center">
              Mapa de Acompanhamento Geográfico
            </h2>
            <p className="text-gray-600 text-center">
              Visualize a distribuição geográfica dos beneficiários em um mapa
              interativo do Brasil.
            </p>
            <div className="mt-4 w-full h-40 bg-gray-100 rounded-lg flex items-center justify-center">
              <div className="text-gray-400 flex flex-col items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10 mb-2"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p>Dados em coleta</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 border border-gray-200 w-full">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Como utilizar este painel?
          </h2>
          <div className="space-y-4">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-emerald-600 font-medium">1</span>
              </div>
              <div>
                <h3 className="text-md font-medium text-gray-800">
                  Inicie a coleta de dados
                </h3>
                <p className="text-gray-600">
                  Avance para as próximas etapas usando o navegador acima para
                  iniciar o processo de coleta.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-emerald-600 font-medium">2</span>
              </div>
              <div>
                <h3 className="text-md font-medium text-gray-800">
                  Acompanhe o progresso
                </h3>
                <p className="text-gray-600">
                  Conforme os dados são coletados, os gráficos e mapas serão
                  atualizados automaticamente.
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0 w-8 h-8 bg-emerald-100 rounded-full flex items-center justify-center mr-3">
                <span className="text-emerald-600 font-medium">3</span>
              </div>
              <div>
                <h3 className="text-md font-medium text-gray-800">
                  Visualize os resultados
                </h3>
                <p className="text-gray-600">
                  Ao término da coleta, você terá acesso a visualizações
                  detalhadas da distribuição dos beneficiários.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmptyDashboard;
